import { styled } from '@mui/material/styles';

const Logo = styled('img', { name: 'skarbonkaLogo' })(({ theme }) => ({
  marginRight: '16px',
  height: 52,
  maxWidth: 138,
  aspectRatio: 'auto 138 / 52',

  [theme.breakpoints.up('sm')]: {},

  [theme.breakpoints.up('md')]: {},

  [theme.breakpoints.up('lg')]: {},
}));

export default Logo;
